import { render, staticRenderFns } from "./DialogEditItem.vue?vue&type=template&id=4ec1c176"
import script from "./DialogEditItem.vue?vue&type=script&lang=ts"
export * from "./DialogEditItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports